var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-follow-fill": "#E02716",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5a2 2 0 0 1 2-2h13l7 8v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5Z",
    fill: "#E02716"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.33 19.96a4.246 4.246 0 0 1-2.465-1.003c-1.367.3-2.666.735-3.966 1.27-1.033 1.837-2 2.773-2.833 2.773-.166 0-.366-.033-.5-.134a.985.985 0 0 1-.566-.902c0-.3.067-1.136 3.233-2.506a23.829 23.829 0 0 0 1.766-4.144c-.4-.802-1.267-2.773-.667-3.776.2-.367.6-.568 1.033-.534.334 0 .667.167.867.434.433.601.4 1.871-.167 3.743a10.074 10.074 0 0 0 2.066 2.673c.7-.134 1.4-.234 2.1-.234 1.566.033 1.8.769 1.766 1.203 0 1.136-1.1 1.136-1.666 1.136Zm-9.329 2.07.1-.033c.466-.167.833-.5 1.1-.935-.5.2-.9.534-1.2.969Zm4.332-10.024h.1c.166.568.166 1.17-.034 1.738-.233-.535-.333-1.136-.2-1.704.034-.034.1-.034.134-.034Zm.331 4.845-.033.067-.034-.033c-.3.768-.633 1.537-1 2.272l.067-.033v.067a19.363 19.363 0 0 1 2.266-.669l-.033-.033h.1c-.5-.501-.966-1.07-1.333-1.638Zm3.668 1.838c.3-.067.567-.067.866-.067.667 0 .8.168.8.268-.2.067-.433.1-.666.067a2.787 2.787 0 0 1-1-.268Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-follow-fill": "#BD080D",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 3v6a2 2 0 0 0 2 2h5l-7-8Z",
    fill: "#BD080D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.7b70ef53c818f7fda3924c0b6ff47460.svg";
export { ForwardRef as ReactComponent };